module.exports = __webpack_public_path__ + "img/birthday.f48dbe0e.svg";